import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import ReactJson from 'react-json-view'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { JSON_ONE99990NW } from './WebhookAPI_Json_Failed_Data';



function WebhookAPI_Json_Failed () {
    const [OptionDataRequest, SetOptionDataRequest] = useState([])
    const [selectedOptionRequest, SetselectedOptionRequest] = useState([])


    const [CollapseExpandRequest, SetCollapseExpandRequest] = useState(false);
    const [StateForCopyResquest, SetStateForCopyRequest] = useState()

    const [CopyText, SetCopyText] = useState ('Copy');
	
	
	    
  function handleClick() {
    SetCopyText('Copied');
  }


    useEffect(() => {

        const optionsRequest = [
            { value: '1', label: 'application/json' },
            
        ];
        SetOptionDataRequest(optionsRequest)

        SetselectedOptionRequest({ value: '1', label: 'application/json' })

    }, [])
    useEffect(() => {
        if (selectedOptionRequest.value == 1) {
            SetStateForCopyRequest(JSON.stringify(JSON_ONE99990NW, null, 2));
        }  else {
            SetStateForCopyRequest("");
        }
    }, [selectedOptionRequest])

    const onClickExpandAllRequest = () => {
        SetCollapseExpandRequest(false)
    }
    const onClickCollapseAllRequest = () => {
        SetCollapseExpandRequest(true)
    }


    const funJSON_DATA_Request = () => {
        if (selectedOptionRequest.value == 1) {
            return (
                <pre>
                 
                  

                    <ReactJson src={JSON_ONE99990NW} collapsed={CollapseExpandRequest} />

                </pre>
            )
        }  
        
        else {
            return (
                <div>
                    No Data
                </div>
            )
        }
    }
    const onChangeSelectedRequest = (data) => {
        SetCollapseExpandRequest(false)
        SetselectedOptionRequest(data)
    }

    return (
        <> 

        <div className="req-json">
      
            <h5>Sale request failed </h5>
            {/* <div class="payload-div">
                200
            </div> */}
            <div class="div-blk">
                
                <div class="select-wrap">
                    <Select
                        value={selectedOptionRequest}
                        onChange={onChangeSelectedRequest}
                        options={OptionDataRequest}
                    />
                    <div class="sc-efHYUO dIxbMO">
                        <CopyToClipboard text={StateForCopyResquest}>
                        <button onClick={handleClick}>{CopyText}</button>
                        </CopyToClipboard>
                                                <button onClick={onClickCollapseAllRequest}> Collapse all </button>
                        <button className='colllapse-sec' onClick={onClickExpandAllRequest}> Expand all </button>
                    </div>
                </div>
                <div class="output">
                    {funJSON_DATA_Request()}
                </div>
            </div>
            </div>
        </>
    )
}

export default WebhookAPI_Json_Failed;